import { gql } from "urql";

export const GET_TPT_REPORT_SUMMARY = gql`
    query fundParseTptReportSummary($clientId: GraphQLObjectId!, $date: GraphQLDateString!) {
        reports(clientId: $clientId, type: "TPT", date: $date, statusIn: [Active, Locked]) {
            _id
            clientId
            clientName
            name
            date
        }
    }
`;
